import client from 'utils/api/client'

const api = {
  getOauthStatus: (username: string) => {
    return client.get('/oauth_status', { params: { username } })
  },
}

export default api
